import { QuestionBase } from './question-base';

export class DatetimeQuestion extends QuestionBase<string> {
  controlType = 'datetime';
  displayFormat: string;
  pickerFormat: string;
  placeholder: string;
  defaultDate: Date;
  max: string;
  min: string;
  cancelText?: string;
  doneText?: string;

  constructor(options: any = {}) {
    super(options);
    this.displayFormat = options['displayFormat'] || 'MMM DD YYYY HH:mm';
    this.pickerFormat = options['pickerFormat'] || 'MMM DD YYYY HH:mm';
    this.placeholder = options['placeholder'] || void 0;
    this.defaultDate = options['defaultDate'] || void 0;
    this.max = options['max'] || undefined;
    this.min = options['min'] || undefined;
    this.cancelText = options['cancelText'] || 'CANCEL';
    this.doneText = options['doneText'] || 'OK';
  }
}
